import { Upload, notification } from "antd"

import { notificationOptions } from "../constants/notification.config"

const MAX_SIZE_MB = 50
const ALLOWED_FILE_EXTENSIONS = [
  "png",
  "jpeg",
  "jpg",
  "pdf",
  "mp4",
  "mov",
  "webm"
]

interface ValidateFileOptions {
  maxSize?: number
  allowedExtensions?: string[]
  defaultResult?: boolean
  sizeMessage?: string
}

const validateFile = (file: File, options: ValidateFileOptions) => {
  const {
    maxSize = MAX_SIZE_MB,
    allowedExtensions = ALLOWED_FILE_EXTENSIONS,
    defaultResult = false,
    sizeMessage = `Uploading file size should not exceed ${maxSize} MB. Please check you file size and try again.`
  } = options

  const fileExtension = file?.name?.split(".")?.pop()?.toLowerCase()

  if (fileExtension && !allowedExtensions?.includes(fileExtension)) {
    void notification?.warning({
      ...notificationOptions.error,
      message: `${file.name} has an unsupported format.`
    })
    return Upload.LIST_IGNORE
  }

  if (file.size / 1024 / 1024 > maxSize) {
    void notification?.warning({
      ...notificationOptions.error,
      message: sizeMessage
    })
    return Upload.LIST_IGNORE
  }

  return defaultResult
}

export { validateFile }
